(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marelune-cult-product"] && !Shopify.designMode) return;
  try {
    
  class MareluneCultProduct {
    constructor(section) {
      this.section = section;
      this.thumbs = Array.from(section.querySelectorAll('[data-cult-thumb]'));
      this.media = Array.from(section.querySelectorAll('[data-cult-media]'));
      this.swatches = Array.from(section.querySelectorAll('[data-cult-swatch]'));
      this.sizeButtons = Array.from(section.querySelectorAll('[data-cult-size]'));
      this.stage = section.querySelector('[data-cult-stage]');
      this.prevButton = section.querySelector('[data-cult-prev]');
      this.nextButton = section.querySelector('[data-cult-next]');
      this.zoomDialog = section.querySelector('[data-cult-zoom]');
      this.zoomFrame = section.querySelector('[data-cult-zoom-frame]');
      this.zoomImage = section.querySelector('[data-cult-zoom-image]');
      this.zoomToggle = section.querySelector('[data-cult-zoom-toggle]');
      this.zoomClose = section.querySelector('[data-cult-zoom-close]');
      this.variantInput = section.querySelector('[data-cult-variant-input]');
      this.currentColor = section.querySelector('[data-cult-current-color]');
      this.currentSize = section.querySelector('[data-cult-current-size]');
      this.price = section.querySelector('[data-cult-price]');
      this.addButton = section.querySelector('button[name="add"]');
      this.mediaMap = this.readMediaMap();
      this.variants = this.readVariants();
      this.visibleMediaIds = this.media.map((item) => item.dataset.mediaId);
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.suppressZoomUntil = 0;
      this.bind();
      const activeSwatch = this.swatches.find((swatch) => swatch.classList.contains('is-active'));
      if (activeSwatch) this.selectColor(activeSwatch.dataset.color, activeSwatch);
      this.updateControls();
    }

    bind() {
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.activateMedia(thumb.dataset.mediaId));
      });

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('click', () => this.selectColor(swatch.dataset.color, swatch));
      });

      this.sizeButtons.forEach((button) => {
        button.addEventListener('click', () => this.selectSize(button.dataset.size, button));
      });

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.showAdjacentMedia(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.showAdjacentMedia(1));

      this.media.forEach((item) => {
        item.addEventListener('click', () => this.openZoom(item));
        item.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.openZoom(item);
          }
        });
      });

      if (this.zoomToggle) this.zoomToggle.addEventListener('click', () => this.toggleZoom());
      if (this.zoomImage) this.zoomImage.addEventListener('click', () => this.toggleZoom());
      if (this.zoomClose) this.zoomClose.addEventListener('click', () => this.closeZoom());
      if (this.zoomDialog) {
        this.zoomDialog.addEventListener('click', (event) => {
          if (event.target === this.zoomDialog) this.closeZoom();
        });
        this.zoomDialog.addEventListener('close', () => this.resetZoom());
      }

      if (this.stage) {
        this.stage.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.showAdjacentMedia(-1);
          if (event.key === 'ArrowRight') this.showAdjacentMedia(1);
        });

        this.stage.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) return;
          this.touchStartX = event.touches[0].clientX;
          this.touchStartY = event.touches[0].clientY;
        }, { passive: true });

        this.stage.addEventListener('touchend', (event) => {
          if (!this.touchStartX || event.changedTouches.length !== 1) return;
          const deltaX = event.changedTouches[0].clientX - this.touchStartX;
          const deltaY = event.changedTouches[0].clientY - this.touchStartY;

          if (Math.abs(deltaX) > 42 && Math.abs(deltaY) < 70) {
            this.suppressZoomUntil = Date.now() + 350;
            this.showAdjacentMedia(deltaX < 0 ? 1 : -1);
          }

          this.touchStartX = 0;
          this.touchStartY = 0;
        }, { passive: true });
      }
    }

    normalize(value) {
      return String(value || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, ' ').trim();
    }

    normalizeMediaId(value) {
      const match = String(value || '').match(/(\d+|demo-[a-z0-9-]+)$/i);
      return match ? match[1] : String(value || '');
    }

    readMediaMap() {
      const element = this.section.querySelector('[data-cult-media-map]');
      if (!element) return null;

      try {
        const value = JSON.parse(element.textContent || 'null');
        if (!value || value.schemaVersion !== 1 || !value.groups || typeof value.groups !== 'object') return null;
        if (!Array.isArray(value.sharedMediaIds)) return null;
        if (this.normalizeMediaId(value.productId) !== this.normalizeMediaId(this.section.dataset.productId)) return null;
        if (!value.sharedMediaIds.every((mediaId) => typeof mediaId === 'string')) return null;

        const groups = Object.values(value.groups);
        const groupsAreValid = groups.every((group) => {
          if (!group || typeof group.label !== 'string' || !Array.isArray(group.mediaIds)) return false;
          if (!group.mediaIds.every((mediaId) => typeof mediaId === 'string')) return false;
          if (group.primaryMediaId && !group.mediaIds.includes(group.primaryMediaId)) return false;
          return true;
        });
        if (!groupsAreValid) return null;

        return value;
      } catch (error) {
        return null;
      }
    }

    readVariants() {
      const element = this.section.querySelector('[data-cult-variants]');
      if (!element) return [];

      try {
        const value = JSON.parse(element.textContent || '[]');
        return Array.isArray(value) ? value : [];
      } catch (error) {
        return [];
      }
    }

    getSelectedColor() {
      const activeSwatch = this.swatches.find((swatch) => swatch.classList.contains('is-active'));
      return activeSwatch?.dataset.color || this.currentColor?.textContent || '';
    }

    getSelectedSize() {
      const activeButton = this.sizeButtons.find((button) => button.classList.contains('is-active'));
      return activeButton?.dataset.size || this.currentSize?.textContent || '';
    }

    findVariant(color, size) {
      const normalizedColor = this.normalize(color);
      const normalizedSize = this.normalize(size);

      return this.variants.find((variant) => {
        if (this.normalize(variant.option1) !== normalizedColor) return false;
        if (this.sizeButtons.length === 0) return true;
        return this.normalize(variant.option2) === normalizedSize;
      }) || null;
    }

    updateSizeAvailability(color) {
      if (this.sizeButtons.length === 0) return;

      this.sizeButtons.forEach((button) => {
        const variant = this.findVariant(color, button.dataset.size);
        const isAvailable = Boolean(variant?.available);
        button.classList.toggle('is-unavailable', !isAvailable);
        button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      });
    }

    updateAddButton(available) {
      if (!this.addButton) return;

      const isAvailable = available !== false;
      this.addButton.disabled = !isAvailable;
      this.addButton.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      this.addButton.textContent = isAvailable
        ? this.addButton.dataset.availableLabel || 'ADD TO CART'
        : this.addButton.dataset.unavailableLabel || 'SOLD OUT';
    }

    updateSelectedVariant(fallbackVariantId, fallbackPrice) {
      const color = this.getSelectedColor();
      const size = this.getSelectedSize();
      const variant = this.findVariant(color, size);
      const variantId = variant?.id || fallbackVariantId;
      const price = variant?.price || fallbackPrice;

      if (this.variantInput && variantId) this.variantInput.value = variantId;
      if (this.price && price) this.price.textContent = price;
      this.updateAddButton(variant ? variant.available : true);
    }

    getMappedMediaIds(color, size) {
      if (!this.mediaMap) return null;

      const normalizedColor = this.normalize(color);
      const normalizedSize = this.normalize(size);
      const groups = Object.values(this.mediaMap.groups);
      let group = null;

      if (normalizedSize) {
        group = groups.find((item) => {
          const itemColor = this.normalize(item.color);
          const itemSize = this.normalize(item.size);
          if (itemColor && itemSize) return itemColor === normalizedColor && itemSize === normalizedSize;

          const combinedSelection = `${normalizedColor} ${normalizedSize}`;
          return this.normalize(item.label) === combinedSelection || this.normalize(item.key) === combinedSelection;
        });
      }

      if (!group) {
        group = groups.find((item) => {
          return this.normalize(item.label) === normalizedColor || this.normalize(item.key) === normalizedColor;
        });
      }
      if (!group) return null;

      const availableIds = new Set(this.media.map((item) => this.normalizeMediaId(item.dataset.mediaId)));
      const orderedIds = [];
      const addId = (mediaId) => {
        const normalizedId = this.normalizeMediaId(mediaId);
        if (availableIds.has(normalizedId) && !orderedIds.includes(normalizedId)) orderedIds.push(normalizedId);
      };

      if (group.primaryMediaId) addId(group.primaryMediaId);
      group.mediaIds.forEach(addId);

      return orderedIds;
    }

    mediaMatchesColor(key, color) {
      const normalizedKey = this.normalize(key);
      const normalizedColor = this.normalize(color);

      if (normalizedColor === 'grass green') return normalizedKey.includes('grass green') || normalizedKey.includes('grass-green');
      if (normalizedColor === 'dark gray') return normalizedKey.includes('dark gray') || normalizedKey.includes('dark-gray') || normalizedKey.includes('black');
      if (normalizedColor === 'ivory') return normalizedKey.includes('ivory') || normalizedKey.includes('pearl white');
      if (normalizedColor === 'pearl') return normalizedKey.includes('pearl') && !normalizedKey.includes('pearl white') && !normalizedKey.includes('ivory');
      if (normalizedColor === 'peacock blue') return normalizedKey.includes('peacock blue');
      if (normalizedColor === 'green') return normalizedKey.includes('green') && !normalizedKey.includes('grass green') && !normalizedKey.includes('grass-green');

      return normalizedKey.includes(normalizedColor);
    }

    isNeutralMedia(key) {
      const normalizedKey = this.normalize(key);
      return normalizedKey.includes('color options') || normalizedKey.includes('color-options') || normalizedKey.includes('size guide') || normalizedKey.includes('size-guide') || normalizedKey.includes('product');
    }

    reorderVisibleMedia(mediaIds) {
      const previousButton = this.section.querySelector('[data-cult-prev]');
      const thumbsContainer = this.thumbs[0]?.parentElement;

      mediaIds.forEach((mediaId) => {
        const mediaItem = this.media.find((item) => this.normalizeMediaId(item.dataset.mediaId) === mediaId);
        const thumbItem = this.thumbs.find((item) => this.normalizeMediaId(item.dataset.mediaId) === mediaId);
        if (mediaItem && previousButton && this.stage) this.stage.insertBefore(mediaItem, previousButton);
        if (thumbItem && thumbsContainer) thumbsContainer.appendChild(thumbItem);
      });
    }

    selectColor(color, swatch) {
      const mappedIds = this.getMappedMediaIds(color, this.getSelectedSize());
      let finalIds = [];

      if (mappedIds) {
        finalIds = mappedIds;
      } else {
        const matchedIds = this.media
          .filter((item) => this.mediaMatchesColor(item.dataset.mediaKey, color))
          .map((item) => this.normalizeMediaId(item.dataset.mediaId));

        const visibleIds = matchedIds.length > 0 ? matchedIds : this.media
          .filter((item) => this.isNeutralMedia(item.dataset.mediaKey))
          .map((item) => this.normalizeMediaId(item.dataset.mediaId));

        finalIds = visibleIds.length > 0 ? visibleIds : this.media.slice(0, 1).map((item) => this.normalizeMediaId(item.dataset.mediaId));
      }

      if (finalIds.length === 0) {
        finalIds = this.media.slice(0, 1).map((item) => this.normalizeMediaId(item.dataset.mediaId));
      }

      this.visibleMediaIds = finalIds;
      this.reorderVisibleMedia(finalIds);

      this.media.forEach((item) => {
        item.hidden = !finalIds.includes(this.normalizeMediaId(item.dataset.mediaId));
        item.classList.remove('is-active');
      });

      this.thumbs.forEach((thumb) => {
        thumb.hidden = !finalIds.includes(this.normalizeMediaId(thumb.dataset.mediaId));
        thumb.classList.remove('is-active');
      });

      const firstMedia = this.media.find((item) => this.normalizeMediaId(item.dataset.mediaId) === finalIds[0]);
      if (firstMedia) this.activateMedia(firstMedia.dataset.mediaId);

      this.swatches.forEach((button) => button.classList.remove('is-active'));
      swatch.classList.add('is-active');

      if (this.currentColor) this.currentColor.textContent = color;
      this.updateSizeAvailability(color);
      this.updateSelectedVariant(swatch.dataset.variantId, swatch.dataset.price);
      this.updateControls();
    }

    selectSize(size, button) {
      this.sizeButtons.forEach((item) => {
        const isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (this.currentSize) this.currentSize.textContent = size;
      this.updateSelectedVariant();

      const mappedIds = this.getMappedMediaIds(this.getSelectedColor(), size);
      if (mappedIds && mappedIds.length > 0) {
        this.visibleMediaIds = mappedIds;
        this.reorderVisibleMedia(mappedIds);

        this.media.forEach((item) => {
          item.hidden = !mappedIds.includes(this.normalizeMediaId(item.dataset.mediaId));
          item.classList.remove('is-active');
        });

        this.thumbs.forEach((thumb) => {
          thumb.hidden = !mappedIds.includes(this.normalizeMediaId(thumb.dataset.mediaId));
          thumb.classList.remove('is-active');
        });

        const firstMedia = this.media.find((item) => this.normalizeMediaId(item.dataset.mediaId) === mappedIds[0]);
        if (firstMedia) this.activateMedia(firstMedia.dataset.mediaId);
        this.updateControls();
      }
    }

    activateMedia(mediaId) {
      this.media.forEach((item) => item.classList.toggle('is-active', item.dataset.mediaId === mediaId));
      this.thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId));
      const activeThumb = this.thumbs.find((thumb) => thumb.dataset.mediaId === mediaId);
      if (activeThumb && !activeThumb.hidden) activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      this.updateControls();
    }

    openZoom(item) {
      if (!this.zoomDialog || !this.zoomImage || !item || item.hidden || Date.now() < this.suppressZoomUntil) return;
      const sourceImage = item.querySelector('img');
      const sourceUrl = sourceImage?.currentSrc || sourceImage?.src || item.dataset.zoomSrc;
      if (!sourceUrl) return;
      this.resetZoom();
      this.zoomImage.src = sourceUrl;
      this.zoomImage.alt = item.dataset.zoomAlt || '';
      this.zoomDialog.showModal();
    }

    closeZoom() {
      if (this.zoomDialog && this.zoomDialog.open) this.zoomDialog.close();
    }

    toggleZoom() {
      if (!this.zoomDialog) return;
      const isZoomed = this.zoomDialog.classList.toggle('is-zoomed');
      if (this.zoomToggle) this.zoomToggle.setAttribute('aria-label', isZoomed ? 'Zoom out' : 'Zoom in');
      if (!isZoomed && this.zoomFrame) {
        this.zoomFrame.scrollTop = 0;
        this.zoomFrame.scrollLeft = 0;
      }
    }

    resetZoom() {
      if (!this.zoomDialog) return;
      this.zoomDialog.classList.remove('is-zoomed');
      if (this.zoomToggle) this.zoomToggle.setAttribute('aria-label', 'Zoom in');
      if (this.zoomFrame) {
        this.zoomFrame.scrollTop = 0;
        this.zoomFrame.scrollLeft = 0;
      }
    }

    getVisibleMediaIds() {
      const visibleIds = this.visibleMediaIds.length > 0 ? this.visibleMediaIds : this.media
        .filter((item) => !item.hidden)
        .map((item) => this.normalizeMediaId(item.dataset.mediaId));

      return visibleIds.filter((mediaId) => this.media.some((item) => {
        return this.normalizeMediaId(item.dataset.mediaId) === mediaId && !item.hidden;
      }));
    }

    showAdjacentMedia(direction) {
      const visibleIds = this.getVisibleMediaIds();
      if (visibleIds.length < 2) return;

      const activeMedia = this.media.find((item) => item.classList.contains('is-active') && !item.hidden);
      const activeMediaId = activeMedia ? this.normalizeMediaId(activeMedia.dataset.mediaId) : visibleIds[0];
      const activeIndex = Math.max(visibleIds.indexOf(activeMediaId), 0);
      const nextIndex = (activeIndex + direction + visibleIds.length) % visibleIds.length;
      const nextMedia = this.media.find((item) => this.normalizeMediaId(item.dataset.mediaId) === visibleIds[nextIndex]);
      if (nextMedia) this.activateMedia(nextMedia.dataset.mediaId);
    }

    updateControls() {
      const shouldShowControls = this.getVisibleMediaIds().length > 1;
      [this.prevButton, this.nextButton].forEach((button) => {
        if (!button) return;
        button.hidden = !shouldShowControls;
        button.disabled = !shouldShowControls;
      });
    }
  }

  document.querySelectorAll('.marelune-cult-product').forEach((section) => new MareluneCultProduct(section));

  } catch(e) { console.error(e); }
})();
})();
